/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddClientsToGroupDto
 */
export interface AddClientsToGroupDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddClientsToGroupDto
     */
    clientIds: Array<string>;
}

/**
 * Check if a given object implements the AddClientsToGroupDto interface.
 */
export function instanceOfAddClientsToGroupDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientIds" in value;

    return isInstance;
}

export function AddClientsToGroupDtoFromJSON(json: any): AddClientsToGroupDto {
    return AddClientsToGroupDtoFromJSONTyped(json, false);
}

export function AddClientsToGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddClientsToGroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientIds': json['clientIds'],
    };
}

export function AddClientsToGroupDtoToJSON(value?: AddClientsToGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientIds': value.clientIds,
    };
}

